<template>
  <div
    v-b-tooltip.hover.top="{ title: filterTooltip, disabled: !filterTooltip }"
  >
    <b-form-input
      v-if="filter.type === 'search' || filter.type === 'quicksearch'"
      :placeholder="filter.placeholder"
      v-model="filter.value"
      @change="onFilterChange(filter)"
      type="search"
    />

    <st-select
      v-if="filter.type === 'select' || filter.type === 'selectablequeryfilter'"
      v-model="filter.value"
      clearable
      :customWidth="customWidth"
      :textField="filter.textField"
      :valueField="filter.valueField"
      :field="filter"
      :model="storedFilters"
      :placeholder="filter.placeholder"
      @change="onFilterChange(filter)"
      @clearFilter="clearChildrenFilter"
      as-filter
      searchable
    />

    <st-select
      v-if="filter.type === 'contains'"
      v-model="filter.value"
      :textField="filter.textField"
      :valueField="filter.valueField"
      :field="filter"
      :model="storedFilters"
      clearable
      :customWidth="customWidth"
      :placeholder="filter.placeholder"
      @change="onFilterChange(filter)"
      :disabled="!filter.options.length"
      @clearFilter="clearChildrenFilter"
      as-filter
      searchable
    />

    <st-date-range
      v-if="filter.type === 'daterange'"
      v-model="filter.value"
      startField="start"
      endField="end"
      :placeholder="filter.placeholder"
      @change="onFilterChange(filter)"
    />

    <st-autocomplete
      v-if="filter.type === 'autocomplete'"
      v-model="filter.value"
      :options="filter.options"
      :name="filter.name"
      :placeholder="filter.label"
      :customWidth="customWidth"
      clearable
      @change="onFilterChange(filter)"
      customClass="st-autocomplete-filter"
      searchable
    >
    </st-autocomplete>
    <b-form-tags
      v-if="filter.type === 'multipletags'"
      v-model="multipleTagsValue"
      separator=","
      tag-pills
      tag-variant="light"
      :add-button-text="$t('APPLICATION.FILTERS.PROJECT_ID_ADD')"
      :duplicate-tag-text="$t('APPLICATION.FILTERS.PROJECT_ID_DUPLICATE')"
      :invalid-tag-text="$t('APPLICATION.FILTERS.PROJECT_ID_INVALID')"
      :placeholder="filter.placeholder"
      remove-on-delete
      :tag-validator="tagValidator"
    />
  </div>
</template>

<script>
import { BFormTags, VBTooltip } from 'bootstrap-vue';
export default {
  name: "StFilterInput",
  components: { BFormTags },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    storedFilters: {
      type: Object,
    },
  },
  methods: {
    onFilterChange(filter) {
      this.$emit("change", filter);
    },
    clearChildrenFilter(filter) {
      this.$emit("clearFilter", filter);
    },
    tagValidator(tag) {
      return !/[;\/@.?]/.test(tag);
    }
  },
  computed: {
    multipleTagsValue: {
      get() {
        if (Array.isArray(this.filter.value)) {
          return this.filter.value;
        }
        return String(this.filter.value || "")
          .split(",")
          .map(value => value.trim())
          .filter(Boolean);
      },
      set(value) {
        this.$set(this.filter, "value", value);
        this.onFilterChange(this.filter);
      },
    },
    customWidth() {
      const width = this.filter?.width;
      if (width === "sm") {
        return "170px";
      }
      if (width === "md") {
        return "260px";
      }
      return "170px";
    },
    filterTooltip() {
      const text = this.filter?.placeholder || this.filter?.label || '';
      return text.trim();
    },
  },
  watch: {
    "filter.value": {
      handler(value) {
        if (value === "") {
          this.onFilterChange(this.filter);
        }
      },
    },
    storedFilters(newValue, oldValue) {
        if (newValue === oldValue) return false;
        if (newValue.project_ids && this.filter.key === 'project_ids') {
            this.multipleTagsValue = newValue.project_ids;
        }
    } 
  },
};
</script>
